module.exports = __webpack_public_path__ + "components/flag/static/square/vn-cd552874c0bff8dadc68dd6f3e75b4a5.svg";